/* ================================================================
   AISTROWISE — Calculadora de sinastría (free, public endpoint)

   SECURITY (non-negotiable):
   - Calls the PUBLIC endpoint POST api.aistrowise.com/synastry-basic.
   - Sends NO credentials: no X-API-Key, no cookies (credentials:'omit').
   - date is mandatory for both people; time is optional (unknown-hour
     path validates as 12:00 via the «No sé la hora» checkbox).
   - Birth data and names for both people are sent ONLY to
     api.aistrowise.com. Never stored (no localStorage), never logged
     (no console), and never attached to any analytics event — every
     track()/dataLayer push here carries structure only, no birth data,
     no names.
   Two-person clone of assets/aw-calculadora.js.
   Spec: aistrowise-claude/docs/specs/2026-07-23-calculadora-sinastria-design.md
   Reveal/theater layer: aistrowise-claude/docs/specs/2026-07-28-sinastria-suspense-redesign.md
   ================================================================ */
(function () {
  'use strict';

  // Plan inglés (2026-10-20): T(texto en español) devuelve el texto en el idioma de la visita (window.awT del
  // layout, diccionario assets/aw-dict-en.js). En español es la identidad: la salida no cambia ni un byte. Los
  // nombres que la API manda en español (signo, planeta, aspecto) pasan por T solo donde se pintan. EN cambia
  // los formatos: punto decimal y casas ordinales (7th).
  var T = (typeof window !== 'undefined' && window.awT) || function (s) { return s; };
  var EN = typeof window !== 'undefined' && window.awLang === 'en';
  // Plan francés (2026-10-21): FR keeps the Spanish formats (decimal comma, the house as a number: «maison 7») and
  // reads the anchors through the same templates as English, with three French needs below (TP, fill, cap).
  var FR = typeof window !== 'undefined' && window.awLang === 'fr';
  function dec(s) { return EN ? s : s.replace('.', ','); }
  function ordinal(n) {
    var v = n % 100, k = n % 10;
    return n + ((v > 10 && v < 14) ? 'th' : k === 1 ? 'st' : k === 2 ? 'nd' : k === 3 ? 'rd' : 'th');
  }

  function pad2(n) { return String(n).length < 2 ? '0' + n : String(n); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmt(tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : ''; });
  }
  // Glosa (2026-10-12): what the named planets, aspect, element or house are,
  // in the both-charts voice of aw-glosa.js. Empty without the helper.
  function sinGlosaHtml(u, seen) {
    var G = window.AWGlosa, g = '';
    if (G && u) {
      if (u.kind === 'aspect' && u.aspect) g = G.sinAspecto(u.aspect.p1_es, u.aspect.p2_es, u.aspect.type_es, seen);
      else if (u.kind === 'elem') g = G.sinElemento(u.key);
      else if (u.kind === 'overlay') g = G.sinCasa(u.planet_es, u.house, seen);
    }
    return g ? '<p class="aw-sin__gloss">' + esc(g) + '</p>' : '';
  }
  function fmtOrb(orb) { return dec(String(Number(orb).toFixed(1))); }
  // Clamp any API score to a renderable 0-100 int — guards against NaN/out-of-range
  // values showing up as "NaN" text or an invalid CSS width.
  function score(n) { n = Math.round(Number(n)); return isFinite(n) ? Math.max(0, Math.min(100, n)) : 0; }
  // The general score keeps one decimal when the API sends one ("72,6"): the
  // decimal reads as computed, and it is the couple's own number. Never
  // fabricate one — an integer-valued float renders "73", not "73,0".
  function scoreDisplay(n) {
    n = Number(n);
    if (!isFinite(n)) return '0';
    n = Math.max(0, Math.min(100, n));
    var r = Math.round(n * 10) / 10;
    return (r % 1 === 0) ? String(Math.round(r)) : dec(r.toFixed(1));
  }

  var RM = false;
  try { RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  // Low-end device downgrade (LatAm mid-tier Android): keep the sequenced
  // reveal but drop transforms, staggers and count-ups — opacity only,
  // final values written directly. Jank on the score is worse than no motion.
  var LOWEND = false;
  try {
    LOWEND = (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) ||
             (navigator.deviceMemory && navigator.deviceMemory <= 2);
  } catch (e) {}
  // On connections that already punish the user, never pad the wait.
  function slowConnection() {
    try {
      var c = navigator.connection;
      return !!(c && (c.saveData || /(^|-)2g$|^3g$/.test(c.effectiveType || '')));
    } catch (e) { return false; }
  }

  // rAF count-up with elapsed-time math (same duration at any refresh rate).
  // Width reserved in ch so the baseline label never dances during the count;
  // the exact final text is always written on the last frame.
  function countUp(el, finalText, ms) {
    if (!el) return;
    var v = parseFloat(String(finalText).replace(',', '.'));
    var places = /[,.]/.test(String(finalText)) ? 1 : 0;
    el.style.display = 'inline-block';
    el.style.minWidth = String(finalText).length + 'ch';
    if (RM || !isFinite(v) || !window.requestAnimationFrame) { el.textContent = finalText; return; }
    var t0 = null;
    window.requestAnimationFrame(function frame(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / ms);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = dec((v * e).toFixed(places));
      if (p < 1) window.requestAnimationFrame(frame);
      else el.textContent = finalText;
    });
  }

  var SUBSCORES = [
    ['atraccion', T('Atracción')], ['conexion_emocional', T('Conexión emocional')],
    ['comunicacion', T('Comunicación')], ['estabilidad', T('Estabilidad')], ['quimica', T('Química')]
  ];

  // Plan francés (2026-10-21): the template with the planet already written in, when the dictionary has that whole
  // phrase. French needs it because the planet sets the words around it («ta Lune» but «ton Soleil», «le Soleil de»):
  // its dictionary carries «Tu Luna», «Tu Sol», «Sol de {nameA}»… Spanish and English have no such entry, so the
  // translated template tr stays and their output does not change.
  function TP(tpl, tr, key, planetEs) {
    var whole = tpl.replace('{' + key + '}', planetEs), t = T(whole);
    return t !== whole ? t : tr;
  }
  // fmt, and in French «de» elided before a name that starts with a vowel («la Lune d’Ana»).
  function fill(tpl, m) {
    if (FR) {
      tpl = tpl.replace(/\bde \{(\w+)\}/g, function (all, k) {
        return /^[aeiouyàâäéèêëîïôöùûüœæ]/i.test(String(m[k] == null ? '' : m[k])) ? 'd’{' + k + '}' : all;
      });
    }
    return fmt(tpl, m);
  }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  // Frases enteras con huecos (2026-10-20): el inglés ordena distinto («Ana's Sun», «their Moon»).
  // En francés la frase puede empezar por «le Soleil de…»: mayúscula inicial.
  function aspectAnchor(a, names) {
    var m = { p1: T(a.p1_es), p2: T(a.p2_es), aspect: T(a.type_es), nameA: names.a, nameB: names.b, orb: fmtOrb(a.orb) };
    m.left = fill(names.a ? TP('{p1} de {nameA}', T('{p1} de {nameA}'), 'p1', a.p1_es) : TP('Tu {p1}', T('Tu {p1}'), 'p1', a.p1_es), m);
    m.right = fill(names.b ? TP('{p2} de {nameB}', T('{p2} de {nameB}'), 'p2', a.p2_es) : TP('su {p2}', T('su {p2}'), 'p2', a.p2_es), m);
    var s = fmt(T('{left} en {aspect} con {right}, a {orb}° de exactitud'), m);
    return FR ? cap(s) : s;
  }
  // En inglés y en francés, la misma frase en plantillas (overlayAnchorTpl, abajo). El español sigue en el código de siempre.
  function overlayAnchor(o, names) {
    if (typeof window !== 'undefined' && (window.awLang === 'en' || window.awLang === 'fr')) return overlayAnchorTpl(o, names);
    var whoH = o.owner === 'b' ? (names.a ? 'de ' + names.a : 'tuya') : (names.b ? 'de ' + names.b : 'suya');
    // Sin nombre, «Tu Marte», como aspectAnchor, nunca «Marte de Tú» (25-sep).
    if (o.owner !== 'b' && !names.a) return 'Tu ' + o.planet_es + ' cae en la casa ' + o.house + ' ' + whoH;
    var whoP = o.owner === 'b' ? (names.b || 'la otra persona') : names.a;
    return o.planet_es + ' de ' + whoP + ' cae en la casa ' + o.house + ' ' + whoH;
  }

  // Cross-page attribution (spec 2026-07-29): the natal calculator's relational
  // beat links here with ?de=natal. Read ONCE into memory — never storage — and
  // carrying no birth data. When present, every event gains source:'natal'.
  var srcNatal = false;
  try { srcNatal = typeof location !== 'undefined' && /(?:^|[?&])de=natal(?:&|$)/.test(location.search); } catch (e) {}

  // overlayAnchor en plantillas: dueño del planeta (owner) y de la casa (host), con o sin nombre. En inglés la casa
  // llega ordinal («7th»).
  // En inglés la frase puede empezar por «the other person's»: mayúscula inicial.
  function overlayAnchorTpl(o, names) {
    var host = o.owner === 'b' ? names.a : names.b;
    var m = { planet: T(o.planet_es), house: EN ? ordinal(o.house) : o.house, host: host };
    var s, P = o.planet_es;
    if (o.owner !== 'b' && !names.a) {
      s = fill(host ? TP('Tu {planet} cae en la casa {house} de {host}', T('Tu {planet} cae en la casa {house} de {host}'), 'planet', P)
        : TP('Tu {planet} cae en la casa {house} suya', T('Tu {planet} cae en la casa {house} suya'), 'planet', P), m);
    } else {
      m.owner = o.owner === 'b' ? (names.b || T('la otra persona')) : names.a;
      if (host) s = fill(TP('{planet} de {owner} cae en la casa {house} de {host}', T('{planet} de {owner} cae en la casa {house} de {host}'), 'planet', P), m);
      else s = fill(o.owner === 'b' ? TP('{planet} de {owner} cae en la casa {house} tuya', T('{planet} de {owner} cae en la casa {house} tuya'), 'planet', P)
        : TP('{planet} de {owner} cae en la casa {house} suya', T('{planet} de {owner} cae en la casa {house} suya'), 'planet', P), m);
    }
    return EN || FR ? cap(s) : s;
  }

  function track(name, params) {
    // Analytics hook, mirrors aw-calculadora.js. Intentionally carries NO
    // birth data and NO names — structure only. params (11-sep): solo claves de
    // estructura, hoy lock_key en la compra en el candado.
    var payload = { event: name };
    if (params) { for (var k in params) { if (Object.prototype.hasOwnProperty.call(params, k) && k !== 'event') payload[k] = params[k]; } }
    if (srcNatal) payload.source = 'natal';
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('aw:track', { detail: payload })); } catch (e) {}
  }

  /* Compra en el candado (2026-09-11, decisión del founder). Con la palanca
     candado_inline_buy, el clic en un candado abre este panel justo debajo de su
     enlace en vez de llevar a la landing (en astro, las llegadas por candado
     compraban en 1 de 142 sesiones). Espejo del panel de aw-astromapa-teaser.js y
     solo copy ya aprobado: la cabecera cita el propio candado tal como se pintó, la
     primera línea es la segunda frase del gancho del puente, la segunda la letra
     fina, la cifra la pinta Shopify (aw-price desde el i18n, confianza de tema,
     entra tal cual) y el form es el mismo /cart/add de la caja de compra de la
     landing, que intercepta aw-cart-add.js. Sin i18n completo no hay panel y el
     candado navega como siempre. Constructores puros, probados en Node. */
  function buyReady(i18n) {
    return !!(i18n && i18n.buyVariant && String(i18n.buyPrice || '').trim() && i18n.buyCta && i18n.buyAction);
  }
  function buyHead(text) {
    var s = String(text == null ? '' : text).replace(/\s+/g, ' ').trim();
    return s ? '«' + s + '»' : '';
  }
  function buyPanelHtml(o) {
    o = o || {};
    var lines = (o.lines || []).filter(function (l) { return l != null && String(l).trim() !== ''; });
    return '<div class="aw-sin__buy" id="' + esc(o.id) + '" data-aw-sin-buy="' + esc(o.key) + '" role="group" aria-label="' + esc(o.title) + '">' +
      '<div class="aw-sin__buy-top">' +
        (o.lead ? '<span class="aw-sin__lock-chip">' + esc(o.lead) + '</span>' : '') +
        '<button type="button" class="aw-sin__buy-close" data-aw-sin-buy-close aria-label="' + esc(o.closeLabel) + '">' +
          '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true" focusable="false"><path d="M2.5 2.5l9 9M11.5 2.5l-9 9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path></svg>' +
        '</button>' +
      '</div>' +
      (o.head ? '<p class="aw-sin__buy-head">' + esc(o.head) + '</p>' : '') +
      lines.map(function (l) { return '<p class="aw-sin__buy-line">' + esc(l) + '</p>'; }).join('') +
      '<div class="aw-sin__buy-price"><span class="aw-sin__buy-name">' + esc(o.title) + '</span>' + String(o.priceHtml || '') + '</div>' +
      String(o.noteHtml || '') +
      // Las opiniones bajo el nombre (founder, 14-oct): markup del tema (snippets/aw-card-reviews.liquid), nunca de aquí.
      String(o.reviewsHtml || '') +
      '<form action="' + esc(o.action) + '" method="post" class="aw-sin__buy-form" data-aw-sin-buy-form>' +
        '<input type="hidden" name="id" value="' + esc(o.variant) + '">' +
        '<button type="submit" name="add" class="aw-sin__btn"' + (o.available === false ? ' disabled' : '') + '>' + esc(o.cta) + '</button>' +
      '</form>' +
      (o.moreHref && o.moreLabel ? '<a class="aw-sin__buy-more" href="' + esc(o.moreHref) + '" data-aw-sin-buy-more>' + esc(o.moreLabel) + '</a>' : '') +
      '</div>';
  }

  function initSin(root) {
    // 6 data-entry screens (3 per person); intro, calc (theater) and result
    // carry no step number. calc sits between the last data screen and the
    // result: it narrates the real computation while /synastry-basic runs.
    var ORDER = ['intro', 'a-date', 'a-time', 'a-place', 'b-date', 'b-time', 'b-place', 'calc', 'gate', 'result'];
    var STEPNUM = { 'a-date': 1, 'a-time': 2, 'a-place': 3, 'b-date': 4, 'b-time': 5, 'b-place': 6 };
    var STEP_TOTAL = 6;
    var current = 'intro';
    // «Comparte tu sinastría» (24-sep): la promesa del controlador de aw-share.js y la
    // marca de «Abrir en Chrome» (compartir=<diseño>), que se lee al arrancar.
    var shareP = null, shareEscape = '';
    function sharePerson(p) {
      return { date: p.date, time: p.time, place: p.place, lat: p.lat, lon: p.lon, name: p.name, unknown: !!p.timeUnknown };
    }

    var apiUrl = root.getAttribute('data-api-url');
    var placesProxy = (root.getAttribute('data-places-proxy') || '').replace(/\/+$/, '');
    // sesión de Google por persona, memoria de respuestas compartida (aw-places.js, 2026-10-01)
    var places = (typeof AWPlaces !== 'undefined' && placesProxy) ? { a: AWPlaces.client(placesProxy), b: AWPlaces.client(placesProxy) } : null;
    var libUrl = root.getAttribute('data-aw-sin-lib');
    var lang = root.getAttribute('data-lang') || 'ES';
    // Floor derived from measured latency, not vibes: p50 API ~1,25 s + LatAm
    // mobile network overhead ~0,6-1,0 s ≈ 1,9-2,25 s of REAL work. 2600 ms
    // covers it with ≤0,7 s of margin — "the wait is the work" stays true.
    var THEATER_FLOOR = parseInt(root.getAttribute('data-theater-floor'), 10) || 2600;

    var t = {};
    try { t = JSON.parse(root.querySelector('[data-aw-sin-i18n]').textContent); } catch (e) { t = {}; }

    // Stamp the natal source on the delegated data-aw-event hooks (bridge CTA,
    // lock links) so aw-analytics.js attaches source:'natal' via data-awp-*.
    if (srcNatal) {
      try {
        Array.prototype.forEach.call(root.querySelectorAll('[data-aw-event]'), function (el) {
          el.setAttribute('data-awp-source', 'natal');
        });
      } catch (e) {}
    }

    function q(sel) { return root.querySelector(sel); }

    var screens = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-aw-sin-screen]'), function (el) {
      screens[el.getAttribute('data-aw-sin-screen')] = el;
    });
    var chrome = q('[data-aw-sin-chrome]');
    var stepCount = q('[data-aw-sin-stepcount]');
    var progress = q('[data-aw-sin-progress]');
    var progressFill = q('[data-aw-sin-progress-fill]');
    var submitBtn = q('[data-aw-sin-submit]');

    function personEls(p) {
      return {
        name: q('[data-aw-sin-name][data-person="' + p + '"]'),
        day: q('[data-aw-sin-day][data-person="' + p + '"]'),
        month: q('[data-aw-sin-month][data-person="' + p + '"]'),
        year: q('[data-aw-sin-year][data-person="' + p + '"]'),
        hour: q('[data-aw-sin-hour][data-person="' + p + '"]'),
        min: q('[data-aw-sin-min][data-person="' + p + '"]'),
        timeUnknown: q('[data-aw-sin-time-unknown][data-person="' + p + '"]'),
        place: q('[data-aw-sin-place][data-person="' + p + '"]'),
        suggest: q('[data-aw-sin-suggest][data-person="' + p + '"]'),
        error: q('[data-aw-sin-error][data-person="' + p + '"]')
      };
    }

    // ── Places autocomplete state (lat/lon via the Worker proxy; NO API key),
    // one independent set per person. ──
    var ac = {
      a: { lat: null, lon: null, picked: false, seen: false, failed: false, items: [], timer: null },
      b: { lat: null, lon: null, picked: false, seen: false, failed: false, items: [], timer: null }
    };

    var libPromise = null;
    function loadLib() {
      if (!libPromise) {
        libPromise = fetch(libUrl, { credentials: 'omit' })
          .then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); })
          .catch(function () { return null; });
      }
      return libPromise;
    }

    var booted = false;
    var started = false;
    function go(s, opts) {
      current = s;
      if (!started && STEPNUM[s]) { started = true; track('sinastria_start'); loadLib(); } // first real step: prefetch library in parallel
      clearSuggest('a'); clearSuggest('b');
      ORDER.forEach(function (k) { if (screens[k]) screens[k].classList.toggle('is-active', k === s); });
      // La capa de respuestas (SEO) se apaga desde el teatro en adelante. Marca de estado
      // en la raíz, para que el CSS decida sin que el JS sepa nada del bloque hermano.
      root.setAttribute('data-screen', s);
      if (chrome) chrome.classList.toggle('can-back', s !== 'intro' && s !== 'calc' && s !== 'gate' && s !== 'result');
      if (STEPNUM[s]) {
        stepCount.textContent = fmt(T('paso {n} de {total}'), { n: STEPNUM[s], total: STEP_TOTAL });
        progress.classList.add('show');
        progressFill.style.width = (STEPNUM[s] / STEP_TOTAL * 100) + '%';
      } else if (s === 'calc') {
        // Theater keeps the rail visible and full: the form is done, the
        // computation is the last stretch.
        stepCount.textContent = '';
        progress.classList.add('show');
        progressFill.style.width = '100%';
      } else {
        stepCount.textContent = '';
        progress.classList.remove('show');
      }
      if (screens[s]) screens[s].scrollTop = 0;
      if (booted) { try { root.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (e) {} }
      booted = true;
      if (hist) hist.at(s, !!(opts && opts.fromPop));
    }

    function back() {
      if (hist && hist.canBack()) { hist.back(); return; }
      var i = ORDER.indexOf(current);
      if (i > 0) go(ORDER[i - 1]);
    }

    // Historial por pantalla (14-oct, aw-step-history.js): «atrás» del móvil vuelve al paso anterior en vez
    // de cerrar el navegador de Instagram. Salir del teatro o de la puerta descarta el resultado en vuelo (live).
    var calcSeq = 0, calcLeft = false, runTh = null, runCtrl = null;
    function live(id) { return id === calcSeq && !calcLeft; }
    // Salir del teatro o de la puerta cancela el cálculo en curso: teatro parado, petición abortada, botón libre.
    function cancelRun() {
      calcLeft = true;
      theaterClear();
      if (runCtrl) { try { runCtrl.abort(); } catch (e) {} runCtrl = null; }
      setBusy(false);
    }
    var hist = window.AWStepHistory ? window.AWStepHistory.attach({ key: 'awSin', transient: ['calc', 'gate'], landing: 'intro', onPop: function (s) {
      if (s === current) return;
      if (current === 'calc' || current === 'gate') cancelRun();
      go(s, { fromPop: true });
    } }) : null;

    function showError(p, msg) {
      var el = personEls(p).error;
      if (el) { el.textContent = msg; el.classList.add('is-show'); }
    }
    function clearError(p) {
      var el = personEls(p).error;
      if (el) { el.textContent = ''; el.classList.remove('is-show'); }
    }
    function setBusy(b) {
      if (!submitBtn) return;
      submitBtn.classList.toggle('is-busy', b);
      submitBtn.textContent = b ? (t.busyLabel || T('Calculando…')) : (submitBtn.getAttribute('data-label') || submitBtn.textContent);
    }

    // ── email gate (spec 2026-09-08), solo con data-aw-gate en el root ──
    var gateFlow = root.getAttribute('data-aw-gate');
    var gateI18n = {};
    try { gateI18n = JSON.parse(root.querySelector('[data-aw-gate-i18n]').textContent); } catch (e) { gateI18n = {}; }
    function gateOn() { return !!(gateFlow && screens.gate && window.AWGate); }
    // Serie L4 (21-sep): lo que el resultado pintó (AWSinSelect.gateFacts, misma selección que
    // el render). Con un select.js viejo en caché, solo la puntuación, como antes.
    function sinProps(resp, lib) {
      if (window.AWSinSelect && typeof window.AWSinSelect.gateFacts === 'function') {
        try { return window.AWSinSelect.gateFacts(resp, lib && lib.entries); } catch (e) {}
      }
      var g = resp && resp.scores ? Number(resp.scores.general) : NaN;
      return isFinite(g) ? { calc_sin_score: g } : {};
    }
    function showConfirmLine() { var el = root.querySelector('[data-aw-gate-confirm]'); if (el) el.hidden = false; }
    function storageOrNull() { try { return window.localStorage; } catch (e) { return null; } }

    // ── validation (parameterized by person) ────────────────────
    function validDate(p) {
      var el = personEls(p);
      var d = parseInt(el.day.value, 10), y = parseInt(el.year.value, 10);
      return d >= 1 && d <= 31 && y >= 1900 && y <= (new Date().getFullYear() + 1);
    }
    function validTime(p) {
      var el = personEls(p);
      if (el.timeUnknown && el.timeUnknown.checked) return true;
      var h = parseInt(el.hour.value, 10), m = parseInt(el.min.value, 10);
      return h >= 0 && h <= 23 && m >= 0 && m <= 59;
    }
    function validPlace(p) {
      var el = personEls(p);
      return el.place && el.place.value.trim().length >= 2;
    }
    // Place is "ready" once it passes basic validation AND (whenever the
    // autocomplete proxy is working) a suggestion has actually been picked,
    // so lat/lon travel with the request. Mirrors aw-calculadora.js.
    function placeReady(p) {
      if (!validPlace(p)) { showError(p, t.errInvalid || T('Revisa los datos.')); return false; }
      if (!ac[p].picked && ac[p].seen && !ac[p].failed) { showError(p, t.placePick || T('Elige la ciudad de la lista.')); return false; }
      clearError(p);
      return true;
    }
    function screenValid(v) {
      if (!v) return true;
      var person = v.charAt(0);
      var kind = v.slice(2); // 'a-date' -> 'date', 'a-time' -> 'time', 'a-place' -> 'place'
      if (kind === 'date') return validDate(person);
      if (kind === 'time') return validTime(person);
      if (kind === 'place') return placeReady(person);
      return true;
    }

    function dateStr(p) {
      var el = personEls(p);
      return el.year.value + '-' + pad2(parseInt(el.month.value, 10)) + '-' + pad2(parseInt(el.day.value, 10));
    }
    function timeStr(p) {
      var el = personEls(p);
      if (el.timeUnknown && el.timeUnknown.checked) return '12:00';
      return pad2(parseInt(el.hour.value, 10)) + ':' + pad2(parseInt(el.min.value, 10));
    }
    function readPerson(p) {
      var el = personEls(p);
      return {
        name: (el.name && el.name.value.trim()) || '',
        date: dateStr(p),
        time: timeStr(p),
        place: (el.place && el.place.value.trim()) || '',
        lat: ac[p].lat,
        lon: ac[p].lon,
        timeUnknown: !!(el.timeUnknown && el.timeUnknown.checked)
      };
    }

    // ── Places autocomplete (via Cloudflare Worker proxy), per person ──────
    function clearSuggest(p) {
      var el = personEls(p);
      ac[p].items = [];
      if (el.suggest) { el.suggest.innerHTML = ''; el.suggest.hidden = true; }
      if (el.place) el.place.setAttribute('aria-expanded', 'false');
    }
    function renderSuggest(p, items) {
      var el = personEls(p);
      ac[p].items = items || [];
      if (!el.suggest) return;
      if (!ac[p].items.length) { clearSuggest(p); return; }
      el.suggest.innerHTML = ac[p].items.map(function (s, i) {
        return '<li class="aw-sin__suggest-item" role="option" data-i="' + i + '">' +
          '<button type="button" class="aw-sin__suggest-btn" tabindex="-1">' +
          '<span class="aw-sin__c-name">' + esc(s.name) + '</span>' +
          (s.region ? '<span class="aw-sin__c-region">' + esc(s.region) + '</span>' : '') +
          '</button></li>';
      }).join('');
      el.suggest.hidden = false;
      if (el.place) el.place.setAttribute('aria-expanded', 'true');
    }
    function fetchAutocomplete(p, query) {
      if (!places) return;
      var el = personEls(p);
      places[p].suggest(query)
        .then(function (d) {
          ac[p].failed = false;
          var arr = (d && d.predictions) || [];
          var items = arr.slice(0, 5).map(function (pr) {
            return {
              text: pr.description || pr.main_text || '',
              name: pr.main_text || pr.description || '',
              region: pr.secondary_text || '',
              id: pr.place_id || ''
            };
          }).filter(function (x) { return x.text; });
          if (items.length) ac[p].seen = true;
          if (el.place.value.trim().length >= 3) renderSuggest(p, items); // ignore stale
        })
        .catch(function () { ac[p].failed = true; renderSuggest(p, []); });
    }
    function pickSuggestion(p, item) {
      if (!item) return;
      var el = personEls(p);
      el.place.value = item.text;
      ac[p].picked = true;
      clearSuggest(p);
      clearError(p);
      ac[p].lat = null; ac[p].lon = null;
      if (!item.id || !places) return;
      places[p].details(item.id)
        .then(function (d) {
          if (d && d.lat != null && d.lng != null) { ac[p].lat = Number(d.lat); ac[p].lon = Number(d.lng); }
        })
        .catch(function () { ac[p].lat = null; ac[p].lon = null; });
    }

    // ── calculation theater ───────────────────────────────────
    // Every stage line names work /synastry-basic actually performs (build
    // both charts, cross the six free bodies, measure major-aspect orbs).
    // The floor covers the REAL median wait (see THEATER_FLOOR derivation);
    // the API runs in parallel, the skip link appears almost immediately,
    // slow connections and repeat calculations never pay the floor twice.
    var theater = { timers: [], resolveFloor: null, finished: false, everSkipped: false };

    function theaterClear() {
      theater.timers.forEach(function (id) { clearTimeout(id); });
      theater.timers = [];
      theater.finished = true;
    }
    function tt(fn, ms) { theater.timers.push(setTimeout(fn, ms)); }

    function theaterStage(steps, i) {
      var n = steps.length || 1, k = n > 1 ? Math.round(i * 4 / (n - 1)) : 4;
      if (screens.calc) { for (var sc = 0; sc <= k; sc++) screens.calc.classList.add('th-s' + sc); }
      Array.prototype.forEach.call(steps, function (li, j) {
        li.classList.toggle('is-active', j === i);
        li.classList.toggle('is-done', j < i);
        if (j <= i) li.classList.add('is-in');
      });
    }

    function startTheater(names) {
      theaterClear(); // los temporizadores de un teatro anterior (atrás y recalcular) no pintan sobre este
      theater.finished = false;
      var namesEl = q('[data-aw-sin-theater-names]');
      if (namesEl) {
        namesEl.textContent = fmt(t.namesTpl || T('{nameA} y {nameB}'), {
          nameA: names.a || t.defaultNameA || T('Tú'),
          nameB: names.b || t.defaultNameB || T('la otra persona')
        });
      }
      var stepsEl = q('[data-aw-sin-tsteps]');
      // Step 1 has a no-names variant: "la carta de Tú" is not Spanish.
      var step1 = (names.a && names.b && t.thSituar)
        ? fmt(t.thSituar, { nameA: names.a, nameB: names.b })
        : (t.thSituarAnon || T('Situando tu carta y la suya…'));
      var stepTexts;
      if (t.th5) {
        // Gate (spec 2026-09-08): cinco líneas repartidas en el suelo de 7 s (founder, 25-sep).
        stepTexts = [
          names.a ? fmt(t.th1, { nameA: names.a }) : (t.th1Anon || T('Calculando tu carta')),
          names.b ? fmt(t.th2, { nameB: names.b }) : (t.th2Anon || T('Calculando la otra carta')),
          t.th3, t.th4, t.th5
        ];
      } else {
        stepTexts = [
          step1,
          t.thCruzar || T('Cruzando las dos cartas: Sol, Luna, Mercurio, Venus, Marte y Saturno, aspecto por aspecto…'),
          t.thMedir || T('Midiendo el orbe de cada aspecto mayor, sobre posiciones de efemérides de la NASA…')
        ];
      }
      if (stepsEl) {
        stepsEl.innerHTML = stepTexts.map(function (txt) {
          return '<li class="aw-sin__tstep"><span class="aw-sin__tdot" aria-hidden="true"></span>' +
            '<svg class="aw-sin__tcheck" width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2.5 8.5l3.5 3.5 7.5-8" stroke="#A49AF9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
            '<span class="aw-sin__ttext">' + esc(txt) + '</span></li>';
        }).join('');
      }
      var steps = stepsEl ? stepsEl.querySelectorAll('.aw-sin__tstep') : [];
      var slow = q('[data-aw-sin-theater-slow]');
      if (slow) slow.hidden = true;
      var skip = q('[data-aw-sin-theater-skip]');
      if (skip) skip.hidden = true;
      var rail = q('[data-aw-sin-theater-rail] i');
      if (rail) rail.style.width = '0%';
      if (screens.calc) { for (var rr = 0; rr < 8; rr++) screens.calc.classList.remove('th-s' + rr); }
      var status = q('[data-aw-sin-theater-status]');
      if (status) status.textContent = stepTexts[0];

      // A user who already skipped once has voted: later runs barely pause.
      var floor = theater.everSkipped ? Math.min(900, THEATER_FLOOR) : THEATER_FLOOR;

      // Stage schedule across the floor; rail tracks the stages.
      theaterStage(steps, 0);
      if (stepTexts.length === 5) {
        // Las cinco líneas a partes iguales hasta el cierre (200 ms antes del suelo), como el
        // teatro compartido de natal y astro (aw-theater.js, spread); el raíl acompaña.
        var stepMs = Math.floor(Math.max(0, floor - 200) / 5);
        for (var si = 1; si < 5; si++) {
          (function (i) { tt(function () { theaterStage(steps, i); if (rail) rail.style.width = (i + 1) * 20 + '%'; }, i * stepMs); })(si);
        }
        if (rail) tt(function () { rail.style.width = '20%'; }, 60);
        tt(function () {
          Array.prototype.forEach.call(steps, function (li) { li.classList.remove('is-active'); li.classList.add('is-done'); });
          if (rail) rail.style.width = '100%';
        }, Math.max(0, floor - 200));
      } else {
        if (rail) tt(function () { rail.style.width = '22%'; }, 60);
        tt(function () { theaterStage(steps, 1); if (rail) rail.style.width = '52%'; }, 900);
        tt(function () { theaterStage(steps, 2); if (rail) rail.style.width = '82%'; }, 1800);
        tt(function () {
          Array.prototype.forEach.call(steps, function (li) { li.classList.remove('is-active'); li.classList.add('is-done'); });
          if (rail) rail.style.width = '96%';
        }, 2400);
      }
      tt(function () { if (skip) skip.hidden = false; }, 800);
      tt(function () { if (!theater.finished && slow) slow.hidden = false; }, floor + 2500);

      var floorP = new Promise(function (resolve) {
        theater.resolveFloor = resolve;
        tt(resolve, floor);
      });
      if (skip && !skip.getAttribute('data-wired')) {
        skip.setAttribute('data-wired', '1');
        skip.addEventListener('click', function () {
          theater.everSkipped = true;
          track('sinastria_theater_skip'); // structure only
          // Acknowledge the tap even when the API is the bottleneck: the
          // link disappears and the busy line takes its place.
          skip.hidden = true;
          if (!theater.finished && slow) {
            slow.textContent = t.busyLabel || T('Calculando tu sinastría…');
            slow.hidden = false;
          }
          if (theater.resolveFloor) theater.resolveFloor();
        });
      }
      return floorP;
    }

    // ── the call ──────────────────────────────────────────────
    function calculate() {
      clearError('a'); clearError('b');
      var okA = validDate('a') && validTime('a') && validPlace('a');
      var okB = validDate('b') && validTime('b') && validPlace('b');
      if (!okA || !okB) { showError('b', t.errInvalid || T('Revisa los datos.')); return; }
      if (!ac.a.picked && ac.a.seen && !ac.a.failed) { showError('b', t.placePick || T('Elige la ciudad de la lista.')); return; }
      if (!ac.b.picked && ac.b.seen && !ac.b.failed) { showError('b', t.placePick || T('Elige la ciudad de la lista.')); return; }

      var state = { a: readPerson('a'), b: readPerson('b') };
      function personPayload(p) {
        // timeStr() already resolved '12:00' when time_unknown is set —
        // no need to re-branch on it here.
        return {
          name: p.name || '', date: p.date, time: p.time,
          time_unknown: !!p.timeUnknown,
          place: p.place, lat: p.lat, lon: p.lon
        };
      }
      var payload = {
        person_a: personPayload(state.a),
        person_b: personPayload(state.b),
        lang: lang
      };

      var reqId = ++calcSeq; calcLeft = false;
      setBusy(true);
      // Resilience: if the deployed section markup predates the calc screen
      // (theme sync lag), never navigate into a blank screen — no theater,
      // no floor, straight to the result when the API answers.
      var hasCalc = !!screens.calc;
      var floorP;
      if (hasCalc) {
        go('calc');
        track('sinastria_theater_start'); // denominator for the skip rate
        floorP = startTheater({ a: state.a.name, b: state.b.name });
      } else {
        floorP = Promise.resolve();
      }

      // The calc screen has no back button: a stalled connection must not
      // strand the user there. 25 s cap → the normal catch path (b-place +
      // network error message) fires.
      var fetchOpts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        mode: 'cors',
        credentials: 'omit'
      };
      var abortTimer = null;
      try {
        if (window.AbortController) {
          var ctrl = new AbortController();
          runCtrl = ctrl;
          fetchOpts.signal = ctrl.signal;
          abortTimer = setTimeout(function () { ctrl.abort(); }, 25000);
        }
      } catch (e) {}

      var apiP = fetch(apiUrl, fetchOpts).then(function (res) {
        if (!res.ok) { var err = new Error('http'); err.status = res.status; throw err; }
        return res.json();
      }).then(function (data) {
        // Never pad the wait for someone whose connection already punished
        // them: on save-data / 2g / 3g, the floor ends when the work ends.
        if (slowConnection() && theater.resolveFloor) theater.resolveFloor();
        return loadLib().then(function (lib) { return { data: data, lib: lib }; });
      });

      Promise.all([apiP, floorP]).then(function (r) {
        if (abortTimer) clearTimeout(abortTimer);
        if (reqId !== calcSeq) return;
        theaterClear();
        setBusy(false);
        if (!live(reqId)) return;
        var status = q('[data-aw-sin-theater-status]');
        if (status) status.textContent = t.thReady || T('Tu sinastría está lista');
        renderResult(r[0].data, r[0].lib);
        // La tira de «Comparte tu sinastría», justo debajo de la portada (25-sep).
        shareP = null;
        if (window.AWShare && typeof window.AWShare.sinastria === 'function') {
          try { shareP = window.AWShare.sinastria(root, r[0].data, { a: sharePerson(state.a), b: sharePerson(state.b) }, track); } catch (e) { shareP = null; }
        }
        var reveal = function () {
          go('result');
          var title = screens.result && screens.result.querySelector('.aw-sin__screen-title');
          if (title) { try { title.focus({ preventScroll: true }); } catch (e) {} }
          startReveal(r[0].data);
          track('sinastria_complete'); // no birth data, no names
          // Desde «Abrir en Chrome»: la hoja se abre sola en el diseño que tenía.
          if (shareEscape && shareP && shareP.then) {
            var esc = shareEscape;
            shareEscape = '';
            shareP.then(function (ctl) { if (ctl) ctl.open(esc); }).catch(function () {});
          }
        };
        // Gate (spec 2026-09-08) entre el teatro y el resultado. Dura desde el 21-sep
        // (founder): sin «Verlo sin dejar mi email». Con sesión iniciada no sale (shouldShow).
        // Desde «Abrir en Chrome» (shareEscape), tampoco: ya pasó la puerta en el navegador de la app.
        if (!gateOn() || shareEscape || !window.AWGate.shouldShow({ storage: storageOrNull(), search: window.location.search, known: root.hasAttribute('data-aw-gate-known') })) { reveal(); return; }
        go('gate');
        // verifyUrl (18-sep): la API verifica el buzón y elige la vía; la línea de
        // confirmación la pone showRoute cuando llega su respuesta, tras el reveal.
        var gateCfg = {
          flow: 'sinastria', hard: true,
          listId: root.getAttribute('data-aw-gate-list') || '',
          companyId: root.getAttribute('data-aw-gate-company') || '',
          verifyUrl: root.getAttribute('data-aw-gate-verify') || '',
          props: sinProps(r[0].data, r[0].lib),
          storage: storageOrNull(),
          track: track,
          onLead: window.awSendLead,
          errInvalid: gateI18n.errInvalid
        };
        return window.AWGate.run(screens.gate, gateCfg).then(function (out) {
          if (!live(reqId)) return;
          if (out && out.captured) {
            if (out.route && typeof window.AWGate.showRoute === 'function') window.AWGate.showRoute(root, out.route, gateCfg);
            else showConfirmLine();
          }
          reveal();
        });
      }).catch(function (err) {
        if (abortTimer) clearTimeout(abortTimer);
        if (reqId !== calcSeq) return;
        theaterClear();
        setBusy(false);
        if (!live(reqId)) return;
        go('b-place');
        showError('b', errorMessage(err && err.status));
      });
    }

    function errorMessage(status) {
      if (status === 422) return t.err422 || t.errInvalid || T('Revisa los datos: la fecha debe ser válida para las dos personas.');
      if (status === 400) return t.err400 || T('No encontramos uno de los dos lugares. Prueba con el formato «Ciudad, País».');
      if (status === 429) return t.err429 || T('Estamos recibiendo muchas peticiones. Espera un momento y vuelve a intentarlo.');
      if (status === 502) return t.err502 || T('Hubo un error de cálculo. Vuelve a intentarlo en un momento.');
      return t.errNetwork || T('No se pudo completar el cálculo. Revisa tu conexión e inténtalo de nuevo.');
    }

    // ── compra en el candado (2026-09-11) ─────────────────────
    // Con la palanca (data-aw-sin-inline-buy en la raíz) y el i18n completo, el clic
    // normal en un candado abre el panel de compra debajo de su enlace.
    function inlineBuy() { return root.getAttribute('data-aw-sin-inline-buy') === '1' && buyReady(t); }
    // Payload que la franja de la landing lee (2026-09-01): copy de librería y claves
    // de estructura. sessionStorage puede lanzar (modo privado), el clic nunca se rompe.
    function writeHandoff(a) {
      if (!a || !a.hasAttribute('data-aw-handoff-key')) return;
      try {
        sessionStorage.setItem('aw_lock_handoff', JSON.stringify({
          calc: 'sinastria', key: a.getAttribute('data-aw-handoff-key'),
          hook: a.getAttribute('data-aw-handoff-hook') || '',
          seccion: a.getAttribute('data-aw-handoff-seccion') || ''
        }));
      } catch (err) {}
    }
    // La burbuja de WhatsApp se apaga mientras cruza el botón del panel, con la misma
    // clase que publican las landings (body.aw-wa-clear, snippet aw-whatsapp).
    var waWired = false;
    function waClear() {
      var wa = document.querySelector('.aw-whatsapp');
      var f = root.querySelector('[data-aw-sin-buy-form]');
      var hit = false;
      if (wa && f) {
        var w = wa.getBoundingClientRect(), r = f.getBoundingClientRect();
        hit = w.width > 0 && !(r.right < w.left || r.left > w.right || r.bottom < w.top || r.top > w.bottom);
      }
      document.body.classList.toggle('aw-wa-clear', hit);
    }
    function closeBuyPanel(focusBack) {
      var p = root.querySelector('[data-aw-sin-buy]');
      if (!p) return;
      var a = p.previousElementSibling;
      p.parentNode.removeChild(p);
      waClear();
      if (!a || !a.hasAttribute('data-aw-handoff-key')) return;
      a.setAttribute('aria-expanded', 'false');
      a.removeAttribute('aria-controls');
      if (focusBack) { try { a.focus(); } catch (e) {} }
    }
    function openBuyPanel(a) {
      var top0 = a.getBoundingClientRect().top;
      closeBuyPanel(false); // uno solo abierto
      var key = a.getAttribute('data-aw-handoff-key') || '';
      var card = a.closest('.aw-sin__unit--locked');
      var head = card ? card.querySelector('.aw-sin__anchor') : null;
      var id = 'aw-sin-buy-' + (root.getAttribute('data-section-id') || 'x') + '-' + key;
      a.insertAdjacentHTML('afterend', buyPanelHtml({
        id: id, key: key, lead: t.buyLead, closeLabel: t.buyClose,
        head: buyHead(head ? head.textContent : ''),
        lines: [t.buyLine],
        title: t.buyTitle, priceHtml: t.buyPrice, noteHtml: t.buyNote, reviewsHtml: t.buyReviews || '',
        action: t.buyAction, variant: t.buyVariant, available: t.buyAvailable,
        cta: t.buyCta, moreHref: a.getAttribute('href'), moreLabel: t.buyMore
      }));
      a.setAttribute('aria-expanded', 'true');
      a.setAttribute('aria-controls', id);
      // Sin salto: si se cerró un panel de más arriba, el candado pulsado vuelve a su
      // sitio en pantalla. Después, el desplazamiento mínimo para ver el panel entero:
      // su scroll-margin salva la cabecera fija, el banner de cookies y la burbuja.
      // base.css pone scroll-behavior: smooth en <html>, así que la corrección va con la
      // anulación en línea (instantánea, antes de revelar) y el movimiento reducido también.
      var d = a.getBoundingClientRect().top - top0;
      var de = document.documentElement, sb = de.style.scrollBehavior;
      if (d) { de.style.scrollBehavior = 'auto'; try { window.scrollBy(0, d); } catch (e) {} de.style.scrollBehavior = sb; }
      var p = a.nextElementSibling;
      if (p) {
        if (RM) de.style.scrollBehavior = 'auto';
        try { p.scrollIntoView({ block: 'nearest', behavior: RM ? 'auto' : 'smooth' }); } catch (e) {}
        de.style.scrollBehavior = sb;
      }
      if (!waWired) {
        waWired = true;
        window.addEventListener('scroll', waClear, { passive: true });
        window.addEventListener('resize', waClear);
        // Abrir «Ver opiniones» (o llegar sus opiniones, o «Leer más») baja el botón sin scroll (aw-card-reviews.js).
        document.addEventListener('aw:crev-layout', waClear);
      }
      waClear();
      track('sinastria_candado_panel_open', { lock_key: key });
    }

    // ── render the live response ──────────────────────────────
    var lastScores = null;
    function renderResult(resp, lib) {
      var entries = (lib && lib.entries) || {};
      var names = { a: resp.person_a.name || '', b: resp.person_b.name || '' };

      // Repeat calculations must not inherit the previous couple's state:
      // conditional blocks re-hide here and only re-show if THIS response
      // earns them.
      ['[data-aw-sin-dinamica]', '[data-aw-sin-precision]'].forEach(function (sel) {
        var el = q(sel); if (el) el.hidden = true;
      });

      // 1. portada — always renders from resp alone, no library dependency
      var nameA = names.a || t.defaultNameA || T('Tú');
      var nameB = names.b || t.defaultNameB || T('la otra persona');
      q('[data-aw-sin-names]').textContent = fmt(t.namesTpl || T('{nameA} y {nameB}'), { nameA: nameA, nameB: nameB });
      lastScores = resp.scores;
      var instant = RM || LOWEND;
      q('[data-aw-sin-score-general]').textContent = instant ? scoreDisplay(resp.scores.general) : '0';
      var barsHtml = '';
      SUBSCORES.forEach(function (s) {
        var v = score(resp.scores[s[0]]);
        // Width is final from birth; the fill animates via transform:scaleX
        // (compositor-friendly — animating width forces layout on every
        // frame, which janks exactly on mid-tier Android). data-v lets the
        // safety net finalize numerals if the cascade dies.
        var style = 'width:' + v + '%' + (instant ? '' : ';transform:scaleX(0)');
        barsHtml += '<li data-aw-reveal><span>' + esc(s[1]) + '</span><span class="aw-sin__bar"><i data-w="' + v + '" style="' + style + '"></i></span><span class="aw-sin__bar-val" data-v="' + v + '">' + (instant ? v : '0') + '</span></li>';
      });
      q('[data-aw-sin-bars]').innerHTML = barsHtml;
      var meta = resp.meta || {};
      if (meta.time_unknown_a || meta.time_unknown_b) {
        var precEl0 = q('[data-aw-sin-precision]');
        // Honest variant: "una de las horas" is false when BOTH are missing.
        if (meta.time_unknown_a && meta.time_unknown_b && t.precisionBoth) precEl0.textContent = t.precisionBoth;
        precEl0.hidden = false;
      }
      q('[data-aw-sin-portada]').hidden = false;

      // Sin párrafo de entrada bajo el titular desde el 25-sep (founder): la portada habla sola.

      // 2+3+4: named dinámica + readable/locked units — depend on AWSinSelect
      // and the lazily-fetched library. Guarded: a library-fetch failure must
      // never make the (real) calculation look broken — portada/strip/grid
      // below always render regardless of what happens in here.
      // Bridge hook: aspect locks only. Overlay strength is not comparable
      // client-side (the API drops the overlay score) and the informe only
      // guarantees a section per aspect familia (astrologer gate 2026-08-27).
      var topAspectHook = '';
      // One motif hook per page: these three entries share the skeleton
      // "nadie mira / nadie pregunta / ninguno eligió" and two on one screen
      // read as template (astrologer gate 2026-08-27, regla N1).
      var MOTIF = { lock_fam_energia_armonico: 1, lock_fam_estructura_armonico: 1, sol_elem_tierra_tierra: 1 };
      var motifUsed = false;
      try {
        var arq = entries[window.AWSinSelect.archetypeKey(resp)];
        if (arq) {
          q('[data-aw-sin-dinamica-nombre]').textContent = arq.nombre;
          q('[data-aw-sin-dinamica-body]').textContent = arq.body;
          q('[data-aw-sin-dinamica]').hidden = false;
        }

        var unitsEl = q('[data-aw-sin-units]');
        var lockedEl = q('[data-aw-sin-units-locked]');
        var lockLink = (lockedEl && lockedEl.getAttribute('data-lock-link')) || '/pages/sinastria-romantica';

        var readable = window.AWSinSelect.pickReadable(resp, function (k) { return !!entries[k]; });
        var locked = window.AWSinSelect.pickLocked(resp, readable.map(function (u) { return u.key; }));
        // Hard rule (D5): doors never outnumber readable units. If the
        // library failed and nothing readable rendered, no locks either.
        locked = locked.slice(0, readable.length);

        var html = '';
        var gSeen = {}; // planets already explained in this result (aw-glosa.js)
        readable.forEach(function (u) {
          var e = entries[u.key];
          var anchor = u.kind === 'aspect' ? aspectAnchor(u.aspect, names) : e.anchor;
          // Library v2: the insight titular and body lead, the measured fact
          // and its glosa follow (2026-10-12). Entries without titular (stale
          // cached v1 library) render exactly as before.
          var head = e.titular || anchor;
          var fact = e.titular ? '<p class="aw-sin__fact">' + esc(anchor) + '</p>' + sinGlosaHtml(u, gSeen) : '';
          html += '<div class="aw-sin__unit" data-aw-reveal><h3 class="aw-sin__anchor">' + esc(head) + '</h3>' +
                  '<p class="aw-sin__body">' + esc(e.body) + '</p>' + fact + '</div>';
        });
        if (unitsEl) unitsEl.innerHTML = html;
        var unitsHeading = q('[data-aw-sin-units-heading]');
        if (unitsHeading) unitsHeading.hidden = !readable.length;

        var lockedHtml = '';
        locked.forEach(function (u) {
          var anchor = u.kind === 'overlay' ? overlayAnchor(u, names) : aspectAnchor(u.aspect, names);
          // Per-lock door line: the overlay lock names the casas layer, the
          // aspect lock names the real report section its familia maps to.
          var line;
          if (u.kind === 'overlay') {
            line = t.lockOverlay || T('Se lee en tu informe');
          } else {
            var seccion = window.AWSinSelect.lockSection ? window.AWSinSelect.lockSection(u.aspect) : '';
            line = seccion && t.lockAspectTpl ? fmt(t.lockAspectTpl, { seccion: T(seccion) }) : (t.lockOverlay || T('Se lee en tu informe'));
          }
          // Library v2 hook: the locked card leads with the insight the
          // informe would open (entry titular for known aspects, else the
          // familia/casa fallback hook). No hook resolvable -> v1 card.
          var hookE = u.kind === 'aspect' && u.key ? entries[u.key] : null;
          var hookKey = window.AWSinSelect.lockHookKey ? window.AWSinSelect.lockHookKey(u) : '';
          var hookSrc = (hookE && hookE.titular) ? u.key : ((hookKey && entries[hookKey] && entries[hookKey].titular) ? hookKey : '');
          var hook = hookSrc ? entries[hookSrc].titular : '';
          if (hook && MOTIF[hookSrc]) { if (motifUsed) { hook = ''; } else { motifUsed = true; } }
          if (!topAspectHook && hook && u.kind === 'aspect') topAspectHook = hook;
          // Handoff (2026-09-01): the lock key travels in the href and the
          // event payload; hook (library titular) + real report section ride
          // on data attributes for the landing continuity strip. Library
          // copy only — the anchor (chart-derived) never travels.
          var handKey = hookSrc || hookKey || u.key || '';
          var handSeccion = u.kind === 'aspect' && window.AWSinSelect.lockSection ? (window.AWSinSelect.lockSection(u.aspect) || '') : '';
          var handHref = handKey ? lockLink + '?candado=' + encodeURIComponent(handKey) : lockLink;
          lockedHtml += '<div class="aw-sin__unit aw-sin__unit--locked" data-aw-reveal>' +
            '<span class="aw-sin__lock-chip"><svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true"><rect x="3" y="7" width="10" height="7" rx="1.5" stroke="currentColor" stroke-width="1.6"></rect><path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" stroke="currentColor" stroke-width="1.6"></path></svg>' + esc(t.lockChip || T('En el informe')) + '</span>' +
            '<h3 class="aw-sin__anchor">' + esc(hook || anchor) + '</h3>' +
            '<div class="aw-sin__lockbars" aria-hidden="true"><i></i><i></i></div>' +
            (hook ? '<p class="aw-sin__fact">' + esc(anchor) + '</p>' : '') + sinGlosaHtml(u, gSeen) +
            '<a class="aw-sin__lock-link" href="' + esc(handHref) + '" data-aw-event="sinastria_lock_click"' + (srcNatal ? ' data-awp-source="natal"' : '') +
            (handKey ? ' data-awp-lock-key="' + esc(handKey) + '" data-aw-handoff-key="' + esc(handKey) + '" data-aw-handoff-hook="' + esc(hook || '') + '" data-aw-handoff-seccion="' + esc(handSeccion) + '"' : '') +
            '>' + esc(line) + ' <span class="aw-sin__arrow" aria-hidden="true">→</span></a></div>';
        });
        if (lockedEl) lockedEl.innerHTML = lockedHtml;
        // Compra en el candado (11-sep): con la palanca, cada candado se anuncia como
        // desplegable. Sin ella el marcado es el de siempre.
        if (lockedEl && inlineBuy()) {
          Array.prototype.forEach.call(lockedEl.querySelectorAll('[data-aw-handoff-key]'), function (l) { l.setAttribute('aria-expanded', 'false'); });
        }
        // Handoff writer: delegated once (innerHTML re-renders survive).
        // Compra en el candado (11-sep): el clic normal abre el panel y el payload de la
        // franja lo deja «Ver todo lo que incluye», así una llegada posterior por el
        // puente no hereda la franja. El clic con modificador (pestaña nueva) y la
        // palanca apagada siguen exactamente como antes.
        if (lockedEl && !lockedEl.getAttribute('data-aw-handoff-wired')) {
          lockedEl.setAttribute('data-aw-handoff-wired', '1');
          lockedEl.addEventListener('click', function (ev) {
            var tg = ev.target && ev.target.closest ? ev.target : null;
            if (!tg) return;
            var more = tg.closest('[data-aw-sin-buy-more]');
            if (more) { writeHandoff(more.closest('[data-aw-sin-buy]').previousElementSibling); return; }
            if (tg.closest('[data-aw-sin-buy-close]')) { closeBuyPanel(true); return; }
            var a = tg.closest('[data-aw-handoff-key]');
            if (!a) return;
            var inline = inlineBuy() && !(ev.button || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey);
            if (!inline) { writeHandoff(a); return; }
            ev.preventDefault();
            if (a.getAttribute('aria-expanded') === 'true') closeBuyPanel(false);
            else openBuyPanel(a);
          });
          lockedEl.addEventListener('keydown', function (ev) {
            if ((ev.key === 'Escape' || ev.key === 'Esc') && lockedEl.querySelector('[data-aw-sin-buy]')) closeBuyPanel(true);
          });
          // El form del panel es el /cart/add de la landing: aw-cart-add.js lo intercepta
          // en captura y sigue a /cart. Aquí solo la señal, con la clave del candado.
          lockedEl.addEventListener('submit', function (ev) {
            var f = ev.target && ev.target.closest ? ev.target.closest('[data-aw-sin-buy-form]') : null;
            var p = f ? f.closest('[data-aw-sin-buy]') : null;
            if (p) track('sinastria_candado_atc', { lock_key: p.getAttribute('data-aw-sin-buy') || '' });
          });
        }
        if (readable.length || locked.length) track('sinastria_teaser_shown'); // structure only
      } catch (e) {}

      // 5. verified positions strip — always renders, no library dependency
      var strip = '';
      [['a', resp.person_a], ['b', resp.person_b]].forEach(function (pair) {
        var p = pair[1];
        var acLine = p.ascendente
          ? '<li>' + esc(fmt(T('Ascendente en {sign} {deg}'), { sign: T(p.ascendente.sign_es), deg: p.ascendente.deg_min.formatted })) + '</li>'
          : '<li>' + esc(T('Ascendente: se calcula con la hora exacta')) + '</li>';
        strip += '<div class="aw-sin__strip-person"><h4>' + esc(p.name || (pair[0] === 'a' ? T('Primera persona') : T('Segunda persona'))) + '</h4><ul>' +
          '<li>' + esc(fmt(T('Sol en {sign} {deg}'), { sign: T(p.sol.sign_es), deg: p.sol.deg_min.formatted })) + '</li>' +
          '<li>' + esc(fmt(T('Luna en {sign} {deg}'), { sign: T(p.luna.sign_es), deg: p.luna.deg_min.formatted })) + '</li>' +
          acLine + '</ul></div>';
      });
      q('[data-aw-sin-strip]').innerHTML = strip;

      // 6. (la tabla técnica de aspectos se retiró el 25-sep, founder)

      // 7. («La tercera carta», el Sol compuesto, se retiró el 25-sep, founder)

      // 8. Bridge hook line: quotes the strongest aspect lock's titular (already
      // on screen, so no new paid territory is named — D5). Never quotes the
      // technical anchor: no titular resolved -> line hidden. Sin título con los
      // nombres y la frase puente fija desde el 25-sep (founder).
      var bridgeHookEl = q('[data-aw-sin-bridge-hook]');
      if (bridgeHookEl) {
        if (topAspectHook && t.bridgeHookTpl) {
          bridgeHookEl.textContent = fmt(t.bridgeHookTpl, { hook: topAspectHook });
          bridgeHookEl.hidden = false;
        } else {
          bridgeHookEl.hidden = true;
        }
      }
    }

    // ── progressive reveal ────────────────────────────────────
    // Timed cascade for the first fold, IntersectionObserver below it.
    // Guards: the staging class is only ever added here (JS dead = all
    // visible), the observer installs at cascade end or first scroll, and a
    // safety net force-reveals everything after 8 s no matter what.
    var io = null, ioInstalled = false;

    function revealEl(el, delayMs) {
      if (!el) return;
      if (delayMs && !LOWEND) el.style.transitionDelay = delayMs + 'ms';
      el.classList.add('is-in');
    }
    function fillBar(li) {
      // Idempotent: the timed cascade and an early-scroll observer can both
      // reach the same bar — the second call must not restart the count.
      if (li.getAttribute('data-filled')) return;
      li.setAttribute('data-filled', '1');
      var fill = li.querySelector('.aw-sin__bar i');
      var val = li.querySelector('.aw-sin__bar-val');
      var v = fill ? parseInt(fill.getAttribute('data-w'), 10) || 0 : 0;
      if (RM || LOWEND) {
        if (fill) fill.style.transform = '';
        if (val) val.textContent = String(v);
        return;
      }
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (fill) fill.style.transform = 'scaleX(1)';
          if (val) countUp(val, String(v), 600);
        });
      });
    }
    function revealAllNow(result) {
      Array.prototype.forEach.call(result.querySelectorAll('[data-aw-reveal]'), function (el) {
        el.classList.add('is-in');
      });
      // Finalize numbers and fills — idempotent when the cascade already ran.
      Array.prototype.forEach.call(result.querySelectorAll('.aw-sin__bar i'), function (fill) {
        fill.style.transform = 'scaleX(1)';
      });
      var generalNum = q('[data-aw-sin-score-general]');
      if (generalNum && lastScores) generalNum.textContent = scoreDisplay(lastScores.general);
      Array.prototype.forEach.call(result.querySelectorAll('.aw-sin__bar-val'), function (val) {
        var v = val.getAttribute('data-v');
        if (v != null) val.textContent = v;
      });
    }

    // Visibility analytics (structure only): did the doors and the bridge get
    // SEEN? Separate observer so the reveal deadline cannot pollute it.
    // Installed once per page load — a repeat calculation must not
    // double-fire the seen events.
    var seenInstalled = false;
    function installSeenTracking(result) {
      if (seenInstalled) return;
      seenInstalled = true;
      if (!('IntersectionObserver' in window)) return;
      try {
        var targets = [
          [q('[data-aw-sin-units-locked]'), 'sinastria_locks_seen'],
          [result.querySelector('.aw-sin__bridge-card'), 'sinastria_bridge_seen']
        ].filter(function (p) { return p[0]; });
        if (!targets.length) return;
        var seenIO = new IntersectionObserver(function (entries) {
          entries.filter(function (en) { return en.isIntersecting; }).forEach(function (en) {
            var pair = targets.filter(function (p) { return p[0] === en.target; })[0];
            if (pair) track(pair[1]);
            seenIO.unobserve(en.target);
          });
        }, { threshold: 0.4 });
        targets.forEach(function (p) { seenIO.observe(p[0]); });
      } catch (e) {}
    }

    function installIO(result) {
      if (ioInstalled) return;
      ioInstalled = true;
      if (!('IntersectionObserver' in window)) { revealAllNow(result); return; }
      var pending = Array.prototype.filter.call(result.querySelectorAll('[data-aw-reveal]'), function (el) {
        return !el.classList.contains('is-in');
      });
      if (!pending.length) return;
      io = new IntersectionObserver(function (entries) {
        entries.filter(function (en) { return en.isIntersecting; }).forEach(function (en, i) {
          revealEl(en.target, i * 100);
          if (en.target.matches && en.target.matches('li') && en.target.querySelector('.aw-sin__bar')) fillBar(en.target);
          io.unobserve(en.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -12% 0px' });
      pending.forEach(function (el) { io.observe(el); });
    }

    function startReveal(resp) {
      var result = screens.result;
      if (!result) return;
      // Repeat calculation: the old observer watches removed nodes — rebuild.
      if (io) { try { io.disconnect(); } catch (e) {} io = null; }
      ioInstalled = false;
      installSeenTracking(result);
      if (RM) {
        // Reduced motion: everything renders final, instantly.
        Array.prototype.forEach.call(result.querySelectorAll('.aw-sin__bar i'), function (fill) {
          fill.style.transform = '';
        });
        return;
      }
      try {
        result.classList.add('aw-sin__result--staged');
        if (LOWEND) result.classList.add('aw-sin__result--lite'); // opacity only, no transforms
        var head = result.querySelector('.aw-sin__result-head');
        var namesEl = q('[data-aw-sin-names]');
        var generalEl = result.querySelector('.aw-sin__general');
        var precEl = q('[data-aw-sin-precision]');
        var stripEl = q('[data-aw-sin-strip]');
        var stripNote = result.querySelector('.aw-sin__strip-note');
        var bars = result.querySelectorAll('[data-aw-sin-bars] > li');
        var generalNum = q('[data-aw-sin-score-general]');
        var finalGeneral = scoreDisplay(resp.scores.general);

        // De arriba abajo (25-sep): Sol, Luna y Ascendente de cada uno van antes de la portada.
        setTimeout(function () { revealEl(head); revealEl(stripEl); revealEl(stripNote); }, 0);
        setTimeout(function () { revealEl(namesEl); }, 120);
        setTimeout(function () { revealEl(generalEl); }, 250);
        setTimeout(function () {
          if (LOWEND) { generalNum.textContent = finalGeneral; }
          else countUp(generalNum, finalGeneral, 550);
        }, 280);
        Array.prototype.forEach.call(bars, function (li, i) {
          setTimeout(function () { revealEl(li); fillBar(li); }, 1000 + i * 50);
        });
        setTimeout(function () { if (precEl && !precEl.hidden) revealEl(precEl); }, 1700);
        setTimeout(function () { installIO(result); }, 2000);
        window.addEventListener('scroll', function onScroll() {
          window.removeEventListener('scroll', onScroll);
          installIO(result);
        }, { passive: true });
        // Global reveal deadline: whatever the observer state, nothing may
        // still be hidden 3 s after the result mounts. This is the guard
        // that makes "no blank blocks" true rather than hoped-for.
        setTimeout(function () { revealAllNow(result); }, 3000);
      } catch (e) {
        result.classList.remove('aw-sin__result--staged');
        revealAllNow(result);
      }
    }

    // ── wiring ────────────────────────────────────────────────
    Array.prototype.forEach.call(root.querySelectorAll('[data-aw-sin-go]'), function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-aw-sin-go');
        var v = btn.getAttribute('data-aw-sin-validate');
        if (v && !screenValid(v)) return;
        go(target);
      });
    });
    var backBtn = q('[data-aw-sin-back]');
    if (backBtn) backBtn.addEventListener('click', back);

    // time-unknown checkbox: disable that person's hour/min while checked
    Array.prototype.forEach.call(root.querySelectorAll('[data-aw-sin-time-unknown]'), function (cb) {
      cb.addEventListener('change', function () {
        var p = cb.getAttribute('data-person');
        var el = personEls(p);
        if (el.hour) el.hour.disabled = cb.checked;
        if (el.min) el.min.disabled = cb.checked;
      });
    });

    // place autocomplete wiring, one instance per person
    ['a', 'b'].forEach(function (p) {
      var el = personEls(p);
      if (el.place && el.suggest) {
        el.place.addEventListener('input', function () {
          ac[p].lat = null; ac[p].lon = null; ac[p].picked = false; clearError(p); // editing invalidates any prior pick
          var query = el.place.value.trim();
          if (ac[p].timer) clearTimeout(ac[p].timer);
          if (query.length < 3) { clearSuggest(p); return; }
          ac[p].timer = setTimeout(function () { fetchAutocomplete(p, query); }, 350);
        });
        el.place.addEventListener('blur', function () { setTimeout(function () { clearSuggest(p); }, 150); });
        // mousedown (not click) so the pick lands before the input's blur fires
        el.suggest.addEventListener('mousedown', function (e) {
          var li = e.target.closest('[data-i]'); if (!li) return;
          e.preventDefault();
          pickSuggestion(p, ac[p].items[parseInt(li.getAttribute('data-i'), 10)]);
        });
      }
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-aw-sin-why]'), function (btn) {
      btn.addEventListener('click', function () {
        var box = q('#' + btn.getAttribute('data-aw-sin-why'));
        if (box) box.classList.toggle('is-open');
      });
    });
    if (submitBtn) {
      submitBtn.setAttribute('data-label', submitBtn.textContent);
      submitBtn.addEventListener('click', calculate);
    }

    go('intro');

    // ── relleno desde la URL ────────────────────────────────────────────
    // Un asistente que ya conoce fecha, hora y lugar entrega un enlace y esto
    // arranca el calculo solo, en vez de mandar a rellenar tres pantallas.
    // Cae en la pantalla de CALCULO, no en el resultado, asi que la puerta de
    // email aparece igual que si lo hubiera tecleado una persona. AWPrefill
    // borra los parametros de la barra al leerlos: los datos de nacimiento no
    // se quedan en el historial ni viajan en el Referer.
    // Aqui hacen falta DOS personas. Si solo viene una, se dejan sus campos
    // puestos y se espera: media sinastria no se puede calcular, pero ahorrar
    // la mitad del formulario ya vale.
    // «Abrir en Chrome» (24-sep): la marca se lee y sale de la barra antes del relleno,
    // y solo vale con los datos de las dos personas tras el # (ver más abajo).
    if (window.AWShare && typeof window.AWShare.shareEscapeDesign === 'function') {
      shareEscape = window.AWShare.shareEscapeDesign(window.location.hash, ['luna', 'instrumento', 'pliego']);
      if (shareEscape) window.AWShare.dropShareKey();
    }
    if (window.AWPrefill) {
      var pre = window.AWPrefill.read(window.location.search, window.location.hash);
      if (!(pre && pre.desdeHash && pre.b)) shareEscape = '';
      if (pre) {
        var okA = window.AWPrefill.fill(root, 'aw-sin', pre.a, 'a');
        if (okA && pre.a.lat != null && pre.a.lon != null) { ac.a.lat = pre.a.lat; ac.a.lon = pre.a.lon; ac.a.picked = true; }
        var okB = pre.b ? window.AWPrefill.fill(root, 'aw-sin', pre.b, 'b') : false;
        if (okB && pre.b.lat != null && pre.b.lon != null) { ac.b.lat = pre.b.lat; ac.b.lon = pre.b.lon; ac.b.picked = true; }
        if (okA) window.AWPrefill.scrub();
        if (!(okA && okB)) shareEscape = '';
        if (okA && okB) { track('sinastria_prefill'); calculate(); }
        else if (okA) { track('sinastria_prefill_parcial'); }
      }
    } else { shareEscape = ''; }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  // Constructores puros del panel exportados para los tests de Node (mismo patrón que
  // aw-calculadora.js). En Node no hay document y la calculadora no arranca.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { buyReady: buyReady, buyHead: buyHead, buyPanelHtml: buyPanelHtml,
      // Plan inglés (2026-10-20): las frases y formatos que cambian con el idioma, para los tests.
      _aspectAnchor: aspectAnchor, _overlayAnchor: overlayAnchor, _scoreDisplay: scoreDisplay, _fmtOrb: fmtOrb, _subscores: SUBSCORES };
  }
  if (typeof document !== 'undefined') {
    ready(function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-aw-sin]'), initSin);
    });
  }
})();
